import { createContext } from 'react';

import { IErknmFormAgreement } from 'KnmErknmPackage/MainModule/interfaces/IErknmFormAgreement';

interface IAgreementsContext {
  isKnm?: boolean;
  isPm?: boolean;
  isDecision?: boolean;
  agreement?: IErknmFormAgreement;
}

const AgreementsContext = createContext<IAgreementsContext>({});

export { AgreementsContext };
